<template>
  <QDialog v-model="show" transition-show="scale" transition-hide="scale">
    <QCard class="calculator-error-card">
      <QCardSection class="calculator-error-header column items-center q-pa-lg">
        <QIcon color="primary" class="q-mb-md" :name="closeIcon" size="4rem" />
        <h3 class="font-nunito text-primary text-center">No results found.</h3>
      </QCardSection>
      <QCardSection class="calculator-error-body column text-center items-center">
        <p class="font-nunito text-grey-8" style="font-size: 16px">
          Sorry. No results are available as your search criteria was too specific.
        </p>
        <p class="font-nunito text-grey-8" style="font-size: 16px">Please adjust your choices and try again.</p>
      </QCardSection>
      <QCardActions class="calculator-error-action column items-center q-pb-xl">
        <CalculatorButton
          style="max-width: 207px; width: 100%; height: 48px"
          color="primary"
          rounded
          hasChevronIcon
          label="Start a new search"
          outlined
          @click="close"
        />
      </QCardActions>
    </QCard>
  </QDialog>
</template>

<script>
import { QDialog, QCard, QCardSection, QCardActions, QIcon } from 'quasar';
import { ClosePopup } from 'eclipx.ui';
import CalculatorButton from './CalculatorButton';
import { evaCloseCircleOutline } from '@quasar/extras/eva-icons';
export const CALCULATOR_ERROR = 'CALCULATOR_ERROR';

export default {
  name: 'CalculatorDialogError',
  data() {
    return {
      show: false,
      errorStack: 0
    };
  },
  computed: {},
  methods: {
    close: async function () {
      this.show = false;
    }
  },
  created() {
    this.closeIcon = evaCloseCircleOutline;
  },
  beforeCreate() {
    this.$euiNotifications.EventBus.$on(CALCULATOR_ERROR, (params) => {
      this.$nextTick(function () {
        this.show = true;
      });
    });
  },
  directives: {
    ClosePopup
  },
  components: {
    QDialog,
    QCard,
    QCardSection,
    QCardActions,
    QIcon,
    CalculatorButton
  }
};
</script>

<style lang="sass" scoped>
.calculator-error-card
  max-width: 665px
  width: 100%
  min-height: 594px
  justify-content: center
  display: flex
  flex-flow: column wrap
.calculator-error-header
  text-align: center
  h3
    font-weight: 700

.calculator-error-body
  text-align: center
</style>
